import { ReactNode } from 'react';
import { t, Trans } from '@lingui/macro';
import clsx from 'clsx';
import { useIntroducerContactEmail } from 'lendingApi/lendingApiHooks';
import styles from './ErrorCard.module.css';

type TCode = 500 | 404 | 403 | 0;

type TProps = {
  code?: TCode;
  title?: string;
  message: string | ReactNode;
  action?: ReactNode;
  className?: string;
};

export const ErrorCard = ({
  code = 500,
  title,
  message,
  action,
  className,
}: TProps) => {
  const contactEmail = useIntroducerContactEmail();

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.errorCard}>
        <h3 className={styles.title}>{title || getTitle(code)}</h3>

        <p className={styles.message}>
          <span>{message}</span>{' '}
          {code === 500 && (
            <span>
              <Trans>If the problem persists, contact support at</Trans>{' '}
              <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            </span>
          )}
        </p>

        {action && <div className={styles.action}>{action}</div>}
      </div>
    </div>
  );
};

const getTitle = (code: TCode) => {
  switch (code) {
    case 500:
      return `500 - ${t`Internal Error`}`;
    case 404:
      return `404 - ${t`Page not found`}`;
    case 403:
      return `403 - ${t`Access denied`}`;
    default:
      return `000 - Dev error`;
  }
};
